import { gql } from "@apollo/client";

const GET_BACKUP_REQUEST_CONFIG = gql`
  query BackupRequestConfig($params: BackupRequestConfigInputParams!) {
    backupRequestConfig(params: $params) {
      noteTemplate
      disputeTypes {
        disputeTypeId
        disputeTypeName
        disputeTypeKey
        isCustomerDeduction
        children {
          disputeTypeId
          disputeTypeName
          disputeTypeKey
          isCustomerDeduction
        }
      }
      contacts {
        name
        email
      }
    }
  }
`;

export default GET_BACKUP_REQUEST_CONFIG;
